import redirectToAuth from 'authorization-module/helpers/redirectToAuth'
import config from 'const/config'
import { appRegion, authDomain } from 'const/session'
import { getAppSessionItem, setAppSessionItem } from 'helpers/appSessionItem'
import { getAuthScopes } from 'helpers/authScopes'
import { getApigeeClientId } from 'helpers/getApigeeClientId'
import { getTargetOrigin } from 'helpers/getTargetOrigin'
import { getSessionTokenAccounts } from 'helpers/sessionTokenAccounts'
import { setSelectedAccount } from 'helpers/setSelectedAccount'
import { MOCK_AUTH } from 'mocks/ui/const/toggles'
import { isMockData } from 'syf-js-utilities'
import redirectToMockAuth from './redirectToMockAuth'

const {
  APP_ENV,
  AUTH_DOMAIN,
  // where we convert auth code to access token
  CALLBACK_PAGE: finishAppAuthenticationURL
} = config

/**
 * Redirects to auth server using the authorization-module's process flow
 * unless the mockData option is set in the query string params.
 * @returns na
 */
const startAuthentication = (
  idToken?: string,
  generateInitialAuthorizeState = false
): void => {
  if (isMockData(APP_ENV)) {
    return
  }
  // store for reference by mfes that need to confirm which auth server was called
  setAppSessionItem(authDomain, config.AUTH_DOMAIN)

  // store for reference by mfes to determine which API to consume
  setAppSessionItem(appRegion, config.APP_REGION)

  // for IVA integration
  const defaultAccount = getSessionTokenAccounts()[0]
  setSelectedAccount(defaultAccount)

  // retrieve auth config values corresponding to current auth flow
  const scope = getAuthScopes()
  const apigeeAppAPIKey = getApigeeClientId()
  const signinPageURL = getTargetOrigin()

  const authConfig = {
    baseURL: AUTH_DOMAIN,
    clientId: apigeeAppAPIKey,
    redirectURI: finishAppAuthenticationURL,
    loginHintURL: signinPageURL,
    scope,
    idToken
  }

  const isMockingAuth =
    getAppSessionItem(MOCK_AUTH) === 'true' || generateInitialAuthorizeState
  if (isMockingAuth) {
    redirectToMockAuth(authConfig, !generateInitialAuthorizeState)
    return
  }

  // send user to auth server to start authenticating
  redirectToAuth(authConfig)
}

export default startAuthentication
